import { Router } from '@angular/router';
import { AuthenticationService } from './../authentication/authentication.service';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptionsArgs, Request, Response, ConnectionBackend, RequestOptions, XHRBackend } from "@angular/http";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import { environment } from '../../../../environments/environment';

@Injectable()
export class HttpClientService extends Http {

    private _authenticationService: AuthenticationService;
    private _router: Router;

    constructor(
        backend: XHRBackend,
        options: RequestOptions,
        authenticationService: AuthenticationService,
        router: Router
    ) {
        //console.log('HttpClientService > constructor > authenticationService', authenticationService);
        options.headers.set('Authorization', `Bearer ${authenticationService.token}`);
        super(backend, options);
        this._authenticationService = authenticationService;
        this._router = router;
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        // console.log('HttpClientService > request > this._authenticationService.getAuthData()', this._authenticationService.getAuthData());
        let token = this._authenticationService.token;
        // console.log('HttpClientService > request > token', token);
        if (!options) {
            options = new RequestOptions({ headers: new Headers() });
        }
        if (!options.headers) {
            options.headers = new Headers();
        }
        options.headers.set('Authorization', `Bearer ${token}`);
        options.headers.append('Authorization', `Bearer ${token}`);
        options.headers.append('Content-Type', 'application/json');
        // options.headers.append('Accept', 'application/json');
        // options.headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE, PUT');
        // options.headers.append('Access-Control-Allow-Origin', '*');
        // options.headers.append('Access-Control-Allow-Headers', 'X-Requested-With, Content-Type, Origin, Authorization, Accept, Client-Security-Token, Accept-Encoding');

        // console.log('URL', this._appSetting.apiEndPoint, url['url']);
        url['url'] = environment.backendUri + url['url'];
        // console.log('HttpClientService > request > options', options);
        return super.request(url, options).catch(this.catchAuthError(this));
    }

    private catchAuthError(self: HttpClientService) {
        // we have to pass HttpService's own instance here as `self`
        return (res: Response) => {
            console.log(res);
            if (res.status === 401) {
                // Unauthorized
                console.log('HttpClientService > Unauthorized', res);
                this.unauthorized();
            }
            if (res.status === 403) {
                // Forbidden
                console.log('HttpClientService > Forbidden', res);
                this.forbidden();
            }
            if (res.status === 500) {
                // Internal server error
                console.log('HttpClientService > Internal server error', res);
                this.internalServerError();
            }
            if (res.status === 404) {
                // Not found
                console.log('HttpClientService > Not found', res);
                this.notFound();
            }
            return Observable.throw(res);
        };
    }

    private unauthorized(): Observable<any> {
        this._authenticationService.logout();
        this._router.navigate(['pages/auth/login-2']);
        window.location.reload();
        return Observable.empty();
    }

    private forbidden(): Observable<any> {
        this._router.navigate(['pages/errors/error-403']);
        return Observable.empty();
    }

    private internalServerError(): Observable<any> {
        this._router.navigate(['pages/errors/error-500']);
        return Observable.empty();
    }

    private notFound(): Observable<any> {
        this._router.navigate(['pages/errors/error-404']);
        return Observable.empty();
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/http-client/http-client.service.ts